import { render, staticRenderFns } from "./headertabtwo.vue?vue&type=template&id=372d97bc&scoped=true&"
import script from "./headertabtwo.vue?vue&type=script&lang=js&"
export * from "./headertabtwo.vue?vue&type=script&lang=js&"
import style0 from "./headertabtwo.vue?vue&type=style&index=0&id=372d97bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d97bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('372d97bc')) {
      api.createRecord('372d97bc', component.options)
    } else {
      api.reload('372d97bc', component.options)
    }
    module.hot.accept("./headertabtwo.vue?vue&type=template&id=372d97bc&scoped=true&", function () {
      api.rerender('372d97bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/headertabtwo.vue"
export default component.exports